import "./Microvix.module.css";
import Header from "@/reusable_sections/Header";
import LinxMicrovixOErpDasFranquias from "./sections/LinxMicrovixOErpDasFranquias";
import PricingHero from "./sections/PricingHero";
import PortalDeGestaoInteligente from "./sections/PortalDeGestaoInteligente";
import ImageDisplay from "./sections/ImageDisplay";
import Inquiry from "./sections/Inquiry";
import FinalCallToAction from "./sections/FinalCallToAction";
import OnePlatformCompleteControl from "./sections/OnePlatformCompleteControl";
import RodapeInstitucional from "@/reusable_sections/Footer";
import Faq from "./sections/Faq";
export default function MicrovixPage() {
  return <div>
      <Header />
      <LinxMicrovixOErpDasFranquias />
      <PricingHero />
      <OnePlatformCompleteControl />
      <PortalDeGestaoInteligente />
      <ImageDisplay />
      <Faq />
      <Inquiry />
      <FinalCallToAction />
      <RodapeInstitucional />
    </div>;
}